export class ListSaasEntitiesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<SaasEntity>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
